import { MainText, Row, StyledButton, StyledDialog, Text, TextContainer } from './common';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onSave: () => void;
}

export const SwitchKnowledgeBaseSourceModal = ({ isOpen, onClose, onSave }: Props) => (
    <StyledDialog open={isOpen} onClose={onClose}>
        <TextContainer>
            <Text>Switch knowledge source?</Text>
            <MainText>
                Switching your knowledge source will save your current content, but it will be inactive. Only the newly selected source will
                be active.
            </MainText>
        </TextContainer>
        <Row>
            <StyledButton onClick={onClose} variant="contained">
                Cancel
            </StyledButton>
            <StyledButton onClick={onSave} variant="contained" main>
                Yes, change
            </StyledButton>
        </Row>
    </StyledDialog>
);
